import request from '@/utils/request'

// 查询举报列列表
export function listDiscoveryReport(query) {
  return request({
    url: '/discovery/discovery/report/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询举报列分页
export function pageDiscoveryReport(query) {
  return request({
    url: '/discovery/discovery/report/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询举报列详细
export function getDiscoveryReport(data) {
  return request({
    url: '/discovery/discovery/report/detail',
    method: 'get',
    params: data
  })
}

// 新增举报列
export function addDiscoveryReport(data) {
  return request({
    url: '/discovery/discovery/report/add',
    method: 'post',
    data: data
  })
}

// 修改举报列
export function updateDiscoveryReport(data) {
  return request({
    url: '/discovery/discovery/report/edit',
    method: 'post',
    data: data
  })
}

// 删除举报列
export function delDiscoveryReport(data) {
  return request({
    url: '/discovery/discovery/report/delete',
    method: 'post',
    data: data
  })
}

// 删除举报列
export function handleDiscoveryReport(data) {
  return request({
    url: '/discovery/discovery/report/handle',
    method: 'post',
    data: data
  })
}
